import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { navigationService } from "../utils/navigationService";

interface NavigationProviderProps {
  children: React.ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({
  children,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  return <>{children}</>;
};
